module.exports = __webpack_public_path__ + "img/GH-kyujin-webdesign002.12c75420.webp";